var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3520_2429",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0.366211L9.75 9.86621L19.25 0.366211"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.86621L9.04289 10.5733C9.43342 10.9638 10.0666 10.9638 10.4571 10.5733L9.75 9.86621ZM-0.457107 1.07332L9.04289 10.5733L10.4571 9.1591L0.957107 -0.340896L-0.457107 1.07332ZM10.4571 10.5733L19.9571 1.07332L18.5429 -0.340896L9.04289 9.1591L10.4571 10.5733Z",
    fill: "#646464",
    mask: "url(#path-1-inside-1_3520_2429)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.0cecb7b5fa333dec21a1419e71723c0c.svg";
export { ForwardRef as ReactComponent };